<template>
  <div
    class="q-item"
    :class="{ fade: fade && !isLastQuestion }"
    v-buried
    :data-buried="'BG_TIZHIPINGGU_Q' + (questionIndex + 1)"
  >
    <img class="bg" :src="imageData[questionIndex].bgImage" alt="" />
    <div class="content">
      <img class="q-index" :src="imageData[questionIndex].indexImage" />
      <div class="q-box" :style="{ height: boxHeight }">
        <QuestinImage
          class="q-title"
          :data="imageData[questionIndex].titleImage"
        />
        <!-- 问题背景图 -->
        <QuestinImage :data="imageData[questionIndex].questionImageData" />
        <!-- 选项图片 -->
        <div class="options-image-list">
          <QuestinImage
            :data="item.imageData"
            v-for="(item, index) in imageData[questionIndex].options"
            :key="index"
          />
        </div>
        <GroupComponent
          v-if="otherFiled.includes(question[questionIndex].field)"
          @change="bindChange"
          :question="question"
        />
        <template v-else>
          <component
            :is="componentName"
            v-for="(item, index) in question[questionIndex].field_unit"
            :key="index"
            :data="item"
            :positionData="
              imageData[questionIndex].options[index] &&
              imageData[questionIndex].options[index].positionData
            "
            :isFadeOut="isFadeOut && !isLastQuestion"
            :type="question[questionIndex].field_type"
            :sort="item.key"
            :index="index"
            :disabled="disabled"
            :active="active"
            @change="bindChange"
          >
          </component>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import RadioBtn from './radio-btn.vue'
import CheckboxBtn from './checkbox-btn.vue'
import GroupComponent from './group-component.vue'
import QuestinImage from './q-image.vue'
export default {
  props: {
    imageData: {
      type: Array,
      default: () => []
    },
    question: {
      type: Array,
      default: () => []
    },
    questionIndex: {
      type: Number,
      default: 0
    }
  },
  components: { RadioBtn, CheckboxBtn, QuestinImage, GroupComponent },
  computed: {
    componentName() {
      if (this.question[this.questionIndex].field_type == 1) {
        return 'CheckboxBtn'
      } else {
        return 'RadioBtn'
      }
    },
    isLastQuestion() {
      return this.questionIndex >= this.question.length - 1
    },
    bgClass() {
      return {
        backgroundImage:
          'url("' + (this.question[this.questionIndex].bgImage || '') + '")'
      }
    },
    boxHeight() {
      let item = this.imageData[this.questionIndex]
      if (item.options?.length) {
        let optionsHeight = 70
        let optionItem = item.options[item.options.length - 1]
        let imageHeight = optionItem.imageData
          ? optionItem.imageData.top + optionItem.imageData.height
          : 0
        let textHeight = optionItem.positionData
          ? optionItem.positionData.top + optionsHeight
          : 0
        let res = imageHeight > textHeight ? imageHeight : textHeight
        return res + 'px'
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      otherFiled: ['age', 'height', 'weight', 'target_weight'],
      active: '',
      fade: false,
      isFadeOut: false,
      disabled: false
    }
  },
  created() {
    if (this.question[this.questionIndex].field_type == 1) {
      this.active = this.question[this.questionIndex].value || []
    } else {
      this.active = this.question[this.questionIndex].value
    }
  },
  methods: {
    bindSetFadeOut(value) {
      this.fade = value
      this.isFadeOut = value
    },
    bindChange(checkIndex = 0, check) {
      let item = this.question[this.questionIndex]
      let checkKey = item.field_unit[checkIndex].key
      switch (item.field_type) {
        case 0:
          if (this.disabled) {
            return
          }
          if (check) {
            this.active = checkKey
            item.value = this.active
            this.isFadeOut = true
            if (!this.isLastQuestion) {
              this.disabled = true
              setTimeout(() => {
                this.fade = true
                setTimeout(() => {
                  this.$emit('change', this.active)
                  this.disabled = false
                }, 500)
              }, 500)
            } else {
              this.$emit('change', this.active)
            }
          } else {
            this.active = ''
            item.value = ''
            this.$emit('change', this.active)
          }
          break
        case 1:
          if (Array.isArray(this.active)) {
            if (check) {
              let extra =
                this.question[this.questionIndex].field_unit[checkIndex].extra
              if (extra) {
                /*  */
                if (extra.length) {
                  let arr = []
                  this.active.map((item) => {
                    if (!extra.includes(item)) {
                      arr.push(item)
                    }
                  })
                  arr.push(checkKey)
                  this.active = arr
                } else {
                  this.active = [checkKey]
                }
                console.log(this.active)
              } else {
                /*  */
                let filterArr = this.question[
                  this.questionIndex
                ].field_unit.map((item, index) => {
                  if (
                    item.extra &&
                    Array.isArray(item.extra) &&
                    !item.extra.length
                  ) {
                    return index
                  }
                  if (
                    item.extra &&
                    Array.isArray(item.extra) &&
                    item.extra.length &&
                    item.extra.includes(checkIndex)
                  ) {
                    return index
                  }
                })
                filterArr.map((item) => {
                  let index = this.active.indexOf(item + 1)
                  index > -1 && this.active.splice(index, 1)
                })
                !this.active.includes(checkKey) && this.active.push(checkKey)
              }
            } else {
              let curIndex = this.active.findIndex((item) => {
                return item == checkKey
              })
              this.active.splice(curIndex, 1)
            }
          } else {
            this.active = [checkKey]
          }
          item.value = this.active
          this.$emit('change', this.active)
          break
        case 5:
          this.$emit('change')
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.q-item {
  opacity: 1;
  transition: opacity 0.5s ease-in;
  overflow: hidden;

  .bg {
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    object-fit: cover;
  }

  .content {
    .q-index {
      width: 335px;
      object-fit: contain;
      padding: 40px 0px 0px;
      margin: 0px auto;
      height: 62px;
    }

    .q-box {
      position: relative;
      margin-bottom: 20px;

      .q-title {
        width: 100%;
        margin-bottom: 61px;

        .title-image {
          margin: 0 auto 0 20px;
          width: 243px;
          height: 70px;
        }
      }

      .q-image {
        width: 100%;
        position: absolute;
      }
    }
  }
}

.fade {
  opacity: 0;
}
</style>
